<template>
  <div>
    <v-dialog v-model="dialog" max-width="950px">
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <div>
              <v-row no-gutters class="xcard mb-8" style="background:#EBEBEB">
                <v-col cols="12" sm="6" md="5">
                  <v-text-field
                    v-model.trim="concepto.nombre"
                    label="* Nombre del concepto"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="7">
                  <v-text-field
                    v-model.trim="concepto.descripcion"
                    label="* Descripcion del concepto"
                    class="pl-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-checkbox v-model="concepto.opcional" label="Opcional"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-checkbox v-model="concepto.facturable" label="Facturable"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-checkbox v-model="concepto.acepta_descuento" label="acepta descuento"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="3" md="2">
                  <v-checkbox v-model="concepto.es_monto_modificable" label="Modificable"></v-checkbox>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-text-field
                    v-model.number="concepto.monto"
                    type="number"
                    label="* Monto del concepto"
                    class="pr-2 pt-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    v-model.number="concepto.order"
                    type="number"
                    label="Orden/Jerarquia"
                    class="pt-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <v-checkbox
                    v-model="concepto.fecha_modificable"
                    label="Fecha modificable"
                    dense
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-checkbox
                    v-model="concepto.muestra_asignacion"
                    label="Muestra Asignacion"
                    dense
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-checkbox
                    v-model="concepto.recaudacion_general"
                    label="Recaudacion general"
                    dense
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-checkbox v-model="concepto.es_nacional" label="Es nacional" dense hide-details></v-checkbox>
                </v-col>

                <!-- <v-col cols="12">
                  <v-select
                    v-model="nit_sel"
                    :items="nits"
                    item-text="xtext"
                    label="Seleccione el nit"
                    return-object
                    class=""
                    outlined
                    dense
                    hide-details
                  />
                </v-col> -->

                <v-col cols="12" sm="4" md="4">
                  <v-select
                    v-model.number="concepto.asignacion_general"
                    :items="[0, 1, 2]"
                    label="* Asignacion general"
                    class="mt-6 mr-1"
                    outlined
                    dense
                    hide-details
                  />
                </v-col>

                <v-col cols="12" sm="4" md="4">
                  <v-select
                    v-model.number="concepto.unidad_id"
                    :items="umedidas"
                    :loading="loadingmedidas"
                    item-value="codigo"
                    label="* Unidad de Medida"
                    class="mt-6 mr-1"
                    outlined
                    dense
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model.trim="concepto.agrupador"
                    label="* agrupador"
                    class="mt-6"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>

                <!-- <v-col cols="12" sm="4" md="8">
                  <v-select
                    v-model="actividad"
                    :items="uactividades"
                    :loading="loadingactividades"
                    return-object
                    label="Actividad"
                    class="ml-0 mt-6"
                    outlined
                    dense
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="4" md="6">
                  <v-select
                    v-model="concepto.codigo_sin"
                    :items="uproductos"
                    :loading="loadingproductos"
                    item-value="codigoProductoServicio"
                    label="Codigo SIN (Segun actividad)"
                    class="mt-6 mr-2"
                    outlined
                    dense
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="4" md="6">
                  <v-select
                    v-model="docsector"
                    :items="docssector"
                    label="Documento Sector"
                    item-value="id"
                    class="mt-6"
                    outlined
                    dense
                    hide-details
                  />
                </v-col> -->
              </v-row>
            </div>
          </v-container>

          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-3" class="white--text" @click="dialog = !dialog">
            Cerrar
          </v-btn>
          <v-btn color="green darken-3" class="white--text" :disabled="loading || exitoso" @click="save">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { getAccessToken } from '@/accessToken';
  import xaxios from '@/xaxios';
  import axios from 'axios';
  export default {
    data: () => ({
      dialog: false,
      exitoso: false,
      loading: false,
      msg: '',
      loadingmedidas: false,
      loadingproductos: false,
      loadingactividades: false,
      umedidas: [],
      uproductos: [],
      uproductoscopy: [],
      uactividades: [],
      nits: [],
      nit_sel: null,
      docssector: [
        { id: 1, text: 'COMPRA Y VENTA' },
        { id: 11, text: 'SECTOR EDUCATIVO' },
      ],
      docsector: null,
      actividad: null,
      concepto: {
        id: null,
        nombre: null,
        descripcion: null,
        estado: true,
        opcional: false,
        monto: null,
        facturable: false,
        acepta_descuento: false,
        order: 0,
        fecha_modificable: true,
        muestra_asignacion: false,
        recaudacion_general: false,
        asignacion_general: null,
        codigo_documento_sector: null,
        codigo_actividad: null,
        es_nacional: false,
        unidad_id: null,
        codigo_sin: null,
        es_monto_modificable: false,
        agrupador: '',
      },
    }),

    computed: {
      formTitle() {
        return this.concepto.id ? 'Editar Concepto' : 'Registrar nuevo Concepto';
      },
    },

    watch: {
      actividad: function(a) {
        if (!this.actividad) return;
        this.uproductos = this.uproductoscopy.filter((x) => {
          return x.codiigoActividad == a.codigo;
        });
        window.console.log(a.codigo, a.codigo == '620200');
        this.docsector = null;
        if (a.codigo == '620200') this.docsector = 1;
        else if (a.codigo == '620000') this.docsector = 1;
        else if (a.codigo == '853000') this.docsector = 11;
        this.concepto.codigo_documento_sector = this.docsector;
        this.concepto.codigo_actividad = parseInt(this.actividad.codigo);
      },
      nit_sel: function() {
        window.console.log(this.nit_sel);
        this.getactividades(this.nit_sel.apikey);
        this.productosservicios(this.nit_sel.apikey);
      },
    },

    methods: {
      openmodal(item) {
        this.dialog = true;
        this.loading = false;
        this.exitoso = false;
        this.actividad = null;
        this.docsector = null;
        this.concepto.id = null;
        this.concepto.nombre = null;
        this.concepto.descripcion = null;
        this.concepto.opcional = false;
        this.concepto.facturable = false;
        this.concepto.acepta_descuento = false;
        this.concepto.monto = null;
        this.concepto.order = 0;
        this.concepto.fecha_modificable = true;
        this.concepto.muestra_asignacion = false;
        this.concepto.recaudacion_general = false;
        this.concepto.es_monto_modificable = false;
        this.concepto.agrupador = '';
        this.concepto.asignacion_general = null;
        this.concepto.es_nacional = false;
        this.concepto.unidad_id = null;
        this.concepto.codigo_sin = null;
        this.concepto.codigo_documento_sector = null;
        this.concepto.codigo_actividad = null;
        this.msg = '';
        if (item) this.getitem(item);
        this.getunidadesmedida();
        this.getactividades(this.$store.getters.getApiKey);
        this.productosservicios(this.$store.getters.getApiKey);
        this.getNits();
      },
      vallength(str, min = 0, max = 255) {
        if (!str) return true;
        if (str.length < min) return true;
        if (str.length > max) return true;
        return false;
      },
      getunidadesmedida() {
        this.loadingmedidas = true;
        let vue = this;

        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/unidadmedidas`,
          headers: {},
        };
        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((u) => {
              u.text = `(${u.codigo_SIN}) ${u.nombre} [${u.descripcion_SIN}]`;
              u.codigo = parseInt(u.id);
            });
            vue.umedidas = data;
            vue.loadingmedidas = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingmedidas = false;
          });
      },
      getactividades(xapikey) {
        this.loadingactividades = true;
        this.uactividades = [];
        this.actividad = null;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/actividad`,
          headers: {
            apikey: xapikey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.map((u) => {
              u.id = u.codigo;
              u.text = `(${u.codigo}) ${u.descripcion}`;
            });
            let d = data.find((x) => x.id == vue.concepto.codigo_actividad);
            vue.actividad = d;
            vue.uactividades = data;
            vue.loadingactividades = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingactividades = false;
          });
      },
      productosservicios(xapikey) {
        this.loadingproductos = true;
        this.uproductos = [];
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/productosservicios`,
          headers: {
            apikey: xapikey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            /*data = data.filter((x) => {
              return x.codiigoActividad == '853000';
            });*/
            data = data.sort((a, b) => {
              let x = a.codigoProductoServicio;
              let y = b.codigoProductoServicio;
              let f = 0;
              if (x > y) f = 1;
              else if (x < y) f = -1;
              return f;
            });
            data.map((u) => {
              u.codigoProductoServicio = '' + u.codigoProductoServicio;
              u.id = u.codigoProductoServicio;
              u.text = `(${u.codiigoActividad}) ${u.tipoActividad} [${u.descripcion}]`;
              vue.uproductoscopy.push(u);
            });
            vue.uproductos = data;
            //window.console.log(response.data);
            vue.loadingproductos = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingproductos = false;
          });
      },
      getitem(item) {
        //item.id = 18;
        const vue = this;
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let nitstore = this.$store.state.key_facturacion;
        window.console.log('NITSTOREL:::', nitstore);
        // nuevo probar 
        // http://localhost:8092/api/v1/esam/conceptopagounidadnegocio/conceptopago/28/unidadnegocio/11
        // let urlc = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/${item.id}/unidadnegocio/${unidad}`;
        let urlc = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos/${item.id}`;

        // let urlc = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos/${item.id}`;
        let raw = JSON.stringify({ unidad_negocio_id: unidad });
        this.loading = true;
        xaxios.get(urlc, raw).then((data) => {
          let su = data.data;
          // window.console.log('get>', su);
          vue.concepto.id = su.id;
          vue.concepto.nombre = su.nombre;
          vue.concepto.descripcion = su.descripcion;
          vue.concepto.opcional = su.opcional;
          vue.concepto.facturable = su.facturable;
          vue.concepto.acepta_descuento = su.acepta_descuento;
          vue.concepto.monto = su.monto;
          vue.concepto.order = su.order;
          vue.concepto.fecha_modificable = su.fecha_modificable;
          vue.concepto.muestra_asignacion = su.muestra_asignacion;
          vue.concepto.recaudacion_general = su.recaudacion_general;
          vue.concepto.es_monto_modificable = su.es_monto_modificable;
          vue.concepto.agrupador = su.agrupador;
          vue.concepto.asignacion_general = su.asignacion_general;
          vue.concepto.es_nacional = su.es_nacional;
          vue.concepto.unidad_id = su.unidad_id;
          vue.concepto.codigo_sin = su.codigo_sin;
          vue.concepto.codigo_documento_sector = su.codigo_documento_sector;
          vue.concepto.codigo_actividad = su.codigo_actividad;
          vue.docsector = su.codigo_documento_sector;

          let d = vue.uactividades.find((x) => x.id == vue.concepto.codigo_actividad);
          vue.actividad = d;
          vue.loading = false;
        });
      },
      async save() {
        //this.close();
        //window.console.log(JSON.stringify(this.concepto, null, 4));
        this.msg = '';
        if (this.vallength(this.concepto.nombre, 3, 255)) this.msg = 'El nombre debe estar entre 3 y 255 caracteres.';
        if (this.vallength(this.concepto.descripcion, 3, 255))
          this.msg = 'La descripcion debe ser de 3 a 255 caracteres.';
        if (this.vallength(this.concepto.agrupador, 3, 50)) this.msg = 'El agrupador debe ser de 3 a 50 caracteres.';
        if (!this.concepto.monto) this.msg = 'Ingrese un monto superior a cero';
        //if (!this.concepto.asignacion_general) this.msg = 'Seleccione tipo de asignacion general';
        if (!this.concepto.unidad_id) this.msg = 'Seleccione la unidad.';
        //if (!this.concepto.codigo_documento_sector) this.msg = 'Seleccione el sector.';
        //if (!this.concepto.codigo_actividad) this.msg = 'Seleccione la actividad.';
        // if (!this.concepto.codigo_sin) this.msg = 'ingrese el codigo SIN.';
        if (this.msg) return;
        this.loading = true;

        let datos = {
          nombre: this.concepto.nombre,
          descripcion: this.concepto.descripcion,
          estado: true,
          opcional: this.concepto.opcional,
          monto: this.concepto.monto,
          facturable: this.concepto.facturable,
          acepta_descuento: this.concepto.acepta_descuento,
          order: this.concepto.order,
          fecha_modificable: this.concepto.fecha_modificable,
          muestra_asignacion: this.concepto.muestra_asignacion,
          recaudacion_general: this.concepto.recaudacion_general,
          es_monto_modificable: this.concepto.es_monto_modificable,
          agrupador: this.concepto.agrupador,
          asignacion_general: this.concepto.asignacion_general,
          es_nacional: this.concepto.es_nacional,
          unidad_id: this.concepto.unidad_id,
          codigo_sin: this.concepto.codigo_sin,
          codigo_documento_sector: this.concepto.codigo_documento_sector,
          codigo_actividad: this.concepto.codigo_actividad,
        };
        if (this.concepto.id) datos.id = this.concepto.id;

        //window.console.log(JSON.stringify(datos, null, 4));
        let metodo = 'post';
        if (datos.id) metodo = 'put';
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos`;
        var config = {
          method: metodo,
          url: url,
          headers: {
            'Content-Type': 'application/json',
          },
          data: datos,
        };

        await xaxios.request(config)
          .then(({ data }) => {
            let xd = window.Object.assign({}, datos);
            let um = vue.umedidas.find((x) => x.id == xd.unidad_id);
            xd.unidad_medida = um;
            vue.msg = data.data;
            vue.loading = false;
            vue.exitoso = true;
            window.console.log(xd);
            vue.$emit('onsave', xd);
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch((e) => {
            window.console.log(e);
            vue.loading = false;
          });
      },
      async obtenerToknFactura() {
        let idsuc = this.$route.query.idsucursal;
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
      getNits() {
        let vue = this;
        this.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.xtext = `${x.nro} [${x.tipo_facturacion}]`;
            });
            vue.nits = data;
            // window.console.log(data);
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
  };
</script>
